const menuEnMessages = {
  'menu.dashboard': 'Dashboard',
  'menu.notifications': 'Notifications',
};

export default menuEnMessages;
